import { Typography, Container, Stack, useMediaQuery  } from '@mui/material';
import { Timeline, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineSeparator, TimelineItem } from '@mui/lab';
import styles from './Experience.module.css';
import TimelineCard from '../TimelineCard/index.js';
import TimelineCardSmall from '../TinelineCardSmall/index.js';
import data from "./experienceData.js";

export default function Experience() {
    const smallScreen = useMediaQuery('(max-width:600px)');

    return (
        <div className={styles.container} id="experience">
            <Typography variant="h4" color="rgba(255, 255, 255, 87)">Experience</Typography>    
            
            {smallScreen ? 
                <Stack 
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    mt={3}
                >
                    {data.map((item) => (
                        <TimelineCardSmall
                            icon={item.icon} 
                            title={item.title} 
                            company={item.company} 
                            employmentType={item.employmentType} 
                            year={item.year} 
                            date={item.date}
                            description={item.description}
                            location={item.location}
                            current={item.current}
                        />
                    ))}
                </Stack> : 
                <Container maxWidth="lg">
                    <Timeline position='alternate'>
                        {/* <TimelineItem>
                            <TimelineOppositeContent />
                            <TimelineSeparator>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent />
                        </TimelineItem> */}
                        {data.map((item) => (
                            <TimelineCard
                                icon={item.icon} 
                                title={item.title} 
                                company={item.company} 
                                employmentType={item.employmentType} 
                                year={item.year} 
                                date={item.date}
                                description={item.description}
                                location={item.location}
                                current={item.current}
                            />
                        ))}
                    </Timeline>
                </Container>
            }
        </div>
    );
}